import { render, staticRenderFns } from "./PropertiesSoldAndLeased.vue?vue&type=template&id=3771ec52&scoped=true&"
import script from "./PropertiesSoldAndLeased.vue?vue&type=script&lang=ts&"
export * from "./PropertiesSoldAndLeased.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3771ec52",
  null
  
)

export default component.exports